import { Component, OnInit, Input,OnChanges} from '@angular/core';
import {PortalService} from '../../model/PortalService';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ServiceProviderPriceService} from '../../services/service-provider-price.service';
import {ModalService} from 'ngx-dynamic-modal';
import {ServiceProviderPriceModalComponent} from '../../modals/service-provider-price-modal/service-provider-price-modal.component';
import { UpdateServiceProviderPricingModalComponent} from '../../modals/update-service-provider-pricing-modal/update-service-provider-pricing-modal.component';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-service-provider-price',
  templateUrl: './service-provider-price.component.html',
  styleUrls: ['./service-provider-price.component.scss']
})
export class ServiceProviderPriceComponent implements OnInit,OnChanges {

  @Input() portalService:PortalService;

  elements:Array<Object>=[];
  formSearch:FormGroup;
  enabled:boolean;
  isSubm=false;

  constructor(private servicePriceHandler: ServiceProviderPriceService,
              private modal:ModalService,
              private alerta:AlertaService) {
      this.formSearch=new FormGroup(
          {
              'service_provider_pk':new FormControl('',Validators.required),
              'prefix':new FormControl('',Validators.required)
          }
      )
  }

  ngOnChanges(){
      this.formSearch.reset();
      this.isSubm=false;
      this.elements=[];
  }

  ngOnInit() {}

  searchPricing(form){
      this.isSubm=true;
      if(form.valid){
          this.enabled=true;
          let criteria=form.value;
          criteria['portal_pk']=this.portalService.getPkPortal();
          criteria['service_pk']=this.portalService.getPkService();
          this.servicePriceHandler
              .getServiceProviderPrice(criteria)
              .subscribe(results =>{
                  this.elements=results;
                  this.enabled=false;
              })
      }
  }

  createModal() {
        let params={portal_pk:this.portalService.getPkPortal(),service_pk:this.portalService.getPkService()}
        this.modal.addDynamicComponent(ServiceProviderPriceModalComponent, {params}, (res) => {
            console.log(res)
        })
  }

  updateModal(element){
      let params={portal_pk:this.portalService.getPkPortal(),service_pk:this.portalService.getPkService()}
      this.modal.addDynamicComponent(UpdateServiceProviderPricingModalComponent, {element,params}, (res) => {
          let indx=this.elements.indexOf(element);
          this.elements[indx]=res.element;
      })
  }

  deleteElement(element){
      this.alerta.addAlert('confirm','Do you want to Delete this Pricing?')
          .then((result)=>{
              if(result.value){
                  this.enabled=true;
                  this.servicePriceHandler
                      .removeServiceProviderPrice(element.pk)
                      .subscribe( result => {
                      }, error => {
                          console.log(error);
                          this.enabled=false;
                      }, () => {
                          this.alerta.addAlert('success','Pricing Deleted Succesfully!!');
                          let indx=this.elements.indexOf(element);
                          this.elements.splice(indx,1);
                          this.enabled=false
                      })
              }
          })
  }




}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/service-provider-price/service-provider-price.component.ts